import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Profile from "../pages/profile/page";
import Terms from "../pages/terms/page";
import Consent from "../pages/consent/page";
import FAQ from "../pages/faq/page";
import Payment from "../pages/payment/page";
import BookingGuidePage from '../pages/booking-guide/page';
import Privacy from "../pages/privacy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/consent",
    element: <Consent />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "/payment",
    element: <Payment />,
  },
  {
    path: "/booking-guide",
    element: <BookingGuidePage />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
